require('./RACard.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @utilities
const { formatText } = require('core/i18n').i18n;

const CHECKED_ICON_CLASS = 'icon-exito';

class RACard extends React.Component {
    buildFooter() {
        const { rightButtonComponent } = this.props;
        if (!rightButtonComponent) {
            return null;
        }

        return (
            <div className="ra-card__footer">
                <div className="ra-card__right-button">
                    {rightButtonComponent}
                </div>
            </div>
        );
    }

    render() {
        const {
            titleKey,
            titleComponent,
            active,
            children,
            extraClass,
            iconClass,
            checked,
            onClick,
        } = this.props;

        const footer = this.buildFooter();
        const title = titleKey ? formatText(titleKey) : titleComponent;
        const icon = checked ? CHECKED_ICON_CLASS : iconClass;
        const iconClassNames = classnames('ra-card__icon', icon, {
            'ra-card__icon--checked': checked,
        });
        const classNames = classnames('ra-card', {
            'ra-card--active': active,
            [extraClass]: !!extraClass,
        });

        return (
            <section onClick={onClick} className={classNames}>
                <header className="ra-card__header">
                    <div className="ra-card__icon-container">
                        <i className={iconClassNames} />
                    </div>
                    <div className="ra-card__title-container">
                        <h2 className="ra-card__title">{title}</h2>
                    </div>
                </header>
                <div className="ra-card__content">
                    <div>{children}</div>
                </div>
                {footer}
            </section>
        );
    }
}

RACard.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node.isRequired,
    extraClass: PropTypes.string,
    iconClass: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    titleComponent: PropTypes.element,
    titleKey: PropTypes.string,
    rightButtonComponent: PropTypes.element,
    onClick: PropTypes.func,
};

RACard.defaultProps = {
    active: false,
    checked: false,
    titleComponent: null,
    rightButtonComponent: null,
    onClick: () => {},
};

module.exports = RACard;
